<router-outlet></router-outlet>
<div>
    <p class="hello" style="display: block;">salut </p>
</div>